import ImageLogo from "@/assets/images/logo.webp";
import LoginBackgroundImage from "@/assets/images/ParrotBG.webp";
import ErrorBoundary from "@/components/ErrorBoundary/errorBoundary.component";
import Login from "@/components/Login/login.component";
import Register from "@/components/Register/register.component";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/shadcn/components/ui/card";
import { utilClearLoginLocalStorage } from "@/utils/tokens.util";
import { getBuildDate } from "@/utils/utils.util";
import { LockIcon } from "lucide-react";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

type PageLoginProps = {};

const PageLogin: React.FC<PageLoginProps> = () => {
  const { t } = useTranslation();
  const projectName = import.meta.env.VITE_PROJECT_DISPLAY_NAME;
  utilClearLoginLocalStorage();
  const buildDate = getBuildDate();
  const [section, setSection] = useState<"login" | "register">("login");

  useEffect(() => {
    document.title = "Parrot";
    const link = document.querySelector("link[rel*='icon']") as HTMLLinkElement;
    if (link) {
      link.href = "/assets/images/pwa/AppImages/favicon.ico";
    }
  }, []);

  return (
    <div className="mobile-landscape:h-svh mobile-landscape:overflow-y-scroll mobile-landscape:[&::-webkit-scrollbar]:hidden mobile-landscape:[scrollbar-width:none] mobile-landscape:[-ms-overflow-style:none] h-screen w-screen">
      {/* Floating Logo */}
      <div className="fixed top-2 left-2 z-1 flex h-36 items-center">
        <img src={ImageLogo} alt="Logo" className="h-full object-contain" />
      </div>
      <img
        src={LoginBackgroundImage}
        alt=""
        className="fixed top-0 left-0 z-0 h-full w-full object-cover"
      />
      {/* Card */}
      <div className="relative container m-auto">
        <div className="flex h-screen flex-col items-center justify-between">
          <div className="flex w-full max-w-md flex-grow items-center p-5">
            <Card className="m-auto w-full gap-0 rounded-sm border-none bg-neutral-900/95 px-4 py-8 pb-5 align-top opacity-95 shadow-lg">
              <CardHeader className="mb-3 flex flex-col items-center">
                <CardTitle className="text-center text-2xl font-bold text-gray-200">
                  {section === "login" ? t("Login") : t("Register")}
                </CardTitle>
              </CardHeader>
              <CardContent className="text-center">
                {section === "login" ? (
                  <ErrorBoundary key="login">
                    <Login />
                  </ErrorBoundary>
                ) : (
                  <ErrorBoundary key="register">
                    <Register setSection={setSection} />
                  </ErrorBoundary>
                )}
                {/* <div className="mt-1">
                  {section === "login" ? (
                    <div className="text-sm text-gray-300">
                      {t("Don't have an account?")}
                      <Button
                        variant={"link"}
                        className="p-1 font-bold text-blue-400"
                        onClick={() => setSection("register")}
                      >
                        {t("Register")}
                      </Button>
                    </div>
                  ) : (
                    <div className="text-gray-300">
                      {t("Already have an account?")}
                      <Button
                        variant={"link"}
                        className="p-1 font-bold text-blue-400"
                        onClick={() => setSection("login")}
                      >
                        {t("Login")}
                      </Button>
                    </div>
                  )}
                </div> */}
                <div className="mt-3 flex items-center justify-center opacity-90">
                  <LockIcon className="mr-2 h-4 text-gray-300" />
                  <p className="text-sm text-gray-300">
                    {t("Enhanced Security Activated")}
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
      {buildDate && (
        <div className="absolute right-1 bottom-1 text-gray-400">
          {`Build Date: ${buildDate.toLocaleDateString()} ${buildDate.toLocaleTimeString()}`}
        </div>
      )}
    </div>
  );
};

export default PageLogin;
